<template>
  <v-container fluid>
    <v-row justify="center" align="center" fluid class="pt-6 pb-6">
      <p class="display-2 text-center font-weight-bold indigo--text">A Documentation of Youth</p>
    </v-row>
    <v-row class="amber lighten-4" fluid pt-0 pb-0 pl-0 pr-0>
      <v-col cols="8" align="center">
        <v-container style="width:680px">
          <v-img style="width:100%" src="@/assets/Prose/Juan_Lopez/image1.png"></v-img>
          <br />
          <p class="text-sm-left indent">
            I hate the highway. The highway that tore apart the city and split it in two. The city I
            will no longer come to call home. Mama says they built cities for children. Children like us.
            The ones that sit upright with attention to watch the sunset. So that when they look up and the
            sun disappears into the rumble of glass and metal they will see their utopias in the angular
            buildings of the city. Grass no longer grows from this soil. Instead, it births highrises and
            highways. We do not complain. Our streets do not bring us to grand cathedrals or skyscrapers.
            They lead to liquor stores.
          </p>
          <p class="text-sm-left indent">
            I hate liquor stores. The ones they built on every block. The reason why everyone
            drinks. We are not drinking to forget where we are or because we cannot leave. We drink
            because that is all there is to do. And when that is all there is to do all you want is to forget and
            leave. It was not always like this. Mama says, in the beginning, we belonged to the land as she
            let us become acquainted with her rocky shore. Her shore was controlled by large rocks with
            seductive curves, each arch tempting us to touch what had never been touched before. To
            cultivate her earth and admire her delicate flowers.
          </p>
          <p class="text-sm-left indent">
            That is not what happened. We did not dig our feet into the firm sand or swim in her
            shallow bay. Instead, we opened our arms wide and looked up to the stars, praying to a man we
            have yet to meet. The one we call god. And we gave him thanks. And we prayed he would
            make our city great.
          </p>
          <p class="text-sm-left indent">A city.</p>
          <p class="text-sm-left indent">A city is what we wanted.</p>
          <p class="text-sm-left indent">A city belonging to god.</p>
          <p class="text-sm-left indent">
            A city that would shine atop a hill as the children process to the sound of church bells.
            So we raised our shovels and buckets and began hacking away at her shoreline, piercing the earth
            with iron until we had molded her a new set of lungs out of copper and steel. So she bled us
            oceans and birthed us a sky to rule over as we continued to thank our own creations. There was
            nothing left for her to do but cry until the soil was flooded with rain and the air smelled of dew.
            The leaves hung their heads low, hunched over before the land begging for her to stop.
          </p>
          <p class="text-sm-left indent">
            She did not stop and neither did we. We did not put down our axes or lower the shovels
            but instead, with angry fists waving in the air we cursed at our god as we rapidly increased the
            pace. She risked drowning herself to death, leaving the grass croaking for air as it was pulled
            from the earth until she had stripped herself of her green clothing exposing her brown skin. All
            that was left was mud as metal frames cast silhouettes over pools of water containing wire and
            broken glass.
          </p>
          <p class="text-sm-left indent">
            All that was left was not left alone. The mud turned to pristine streets for us to race
            down. Metal frames became skyscrapers to jump from and mazes to get lost in. We invented
            time, created money and preached of an angry god. And we are angry too; growing slick
            tongues and straight backs. Now we get high to meet god; to touch his face and kiss his feet.
            We worship at the altar of a liquor store and find truth at the bottom of a bottle. And you would
            be surprised how much Mama can drink when she tells herself it is water and tries to baptize
            herself in it. Drunkenly we walked past her body, mangled and tired. Mangled and tired she is
            left for the conception of a city.
          </p>
          <p class="text-sm-left indent">A city.</p>
          <p class="text-sm-left indent">A city is what we wanted.</p>
          <p class="text-sm-left indent">A city belonging to god.</p>
          <p class="text-sm-left indent">
            A city that now sits atop a hill as children hang from trees like fruit and church bells
            announce the death of another boy killed by a man. So lately I have come to fear the sound of
            church bells and been wary of the voice of god when it calls to me. And as I sit and the sun hits
            the asphalt I find myself in the middle of a heated discussion. A discussion that does not require
            speaking but smoking cigarette butts stolen off the ashtray that sits atop the front porch.
          </p>
          <p class="text-sm-left indent">Mama says smoking kills.</p>
          <br />
          <p class="text-sm-left indent">Mama keeps her pack of smokes next to her crack pipe.</p>
          <p class="text-sm-left indent">
            The crack pipe her prized possession, one she thinks I know nothing about. I have come
            to discover her habit as sitting on the curb of the cul-de-sac has become a regular occurrence as
            she gets into strange cars belonging to strange men, frantically turning tricks for rock. One butt
            is no longer enough. So I stockpile. Stockpile until I have enough to get a headrush. By now I
            call it a revelation, some sort of intervention that will somehow make it easier to watch her
            stumble out of the 2012 red Subaru STI. And with each drag, I try to convince myself I have
            been enlightened.
          </p>
          <p class="text-sm-left indent">
            I hate my name. The one Mama no longer calls me by. I have become an array of
            incoherent syllables that never match. I no longer ask Mama if she loves me because she would
            tell me that there are things more complicated than love. I hate love. So I no longer ask.
            Instead, I walk two blocks to the nearest liquor store. The one where men sit outside sippin’
            forties as the streetlights flicker on and off. That is where I will meet Joe.
          </p>
          <p class="text-sm-left indent">
            I hate Joe. I know I shouldn’t but I do. Joe had a short scraggly black beard littered with
            gray hairs and occasionally slept in a shopping cart at night. He said he was forty-five and that
            one day he would leave this town to find a home with a white picket fence. Joe never got his
            white picket fence but he did get handed twenty-dollar bills by all the underage kids on the block
            for cigarettes and booze. I met Joe for the first time on my seventh birthday when I decided I
            was old enough to start smoking. Mama caught me smoking one time and loved me the only
            way she knew how: until I was black and blue.
          </p>
          <p class="text-sm-left indent">I have not quit yet.</p>
          <p class="text-sm-left indent">
            During the five minutes that Joe lasts inside, the remaining men will dissect me with their
            stares saying things‘he’s going to be a fag’ and pointing out my ‘dainty wrists.’ And because I
            am young and do not know what they are truly saying I will give them a blank stare and recite
            thank yous believing these to be compliments.
          </p>
          <p class="text-sm-left indent">These are not compliments.</p>
          <p class="text-sm-left indent">
            When Joe comes back out he will be holding a pack of cigarettes and a fifth of whiskey.
            I will take the pack as he trails behind walking me home, occasionally taking swigs between his
            giant steps, making sure I made it back before dark. These silent walks had become a weekly
            occurrence as Joe would waver off the doorstep as the front doors locked. Mama didn't like me
            outside once the streetlights came on. She said it was because she didn’t wanna see me dead, I
            think she was too scared to step foot within the walls of a church. She was never around when I
            was home, usually burrowed away in her room where wooden planks replaced windows and a
            computer screen was used as light. She spent most of her time there scrubbing a pair of
            unwanted fingerprints off a crumbling white wall.
          </p>
          <p class="text-sm-left indent">
            I did not exist beyond the two blocks to the liquor store or underneath the glow of
            streetlights but the street’s light glowed on Joe. Tonight, the bitter burn of brown liquor will
            bring him into a deep depression where he will find himself saying things like ‘I’d be better off
            dead’ and ‘I wish I was never born.’ Once again finding himself surrounded by faces whose
            names he cannot remember, gathered around a fire doused in gasoline, trading anecdotes for the
            opportunity to taste something tangible.
          </p>
          <p class="text-sm-left indent">Another day wasted.</p>
          <p class="text-sm-left indent">Another handle is gone.</p>
          <p
            class="text-sm-left indent"
          >Another starless night reflected upon a murky river where bodies lie, sunken and lifeless.</p>
          <p class="text-sm-left indent">
            What will happen next to Joe will not matter. No one cares about what happens to men
            without white picket fences. The ones who sit outside the liquor store as the dimly lit street
            lights flicker on and off. On and off and on and off as bodies lie, sunken and lifeless. I choose
            not to synthesize those matters. Instead, I will smoke a pack of Marlboro Reds to the very last
            butt and pray they bring divine intervention.
          </p>
        </v-container>
      </v-col>
      <v-col cols="4">
        <AUTH :author="author" />
        <p class="text-sm-left">{{author.bio}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AUTH from "../../../Article/Author.vue";
export default {
  props: ["author"],
  components: {
    AUTH
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>

<style scoped>
.indent {
  text-indent: 1.9em;
}
</style>